<template>
            <mu-radio label="单选框" />
	
</template>
<script>
	export default{
		name:'radio'
	}
</script>


// WEBPACK FOOTER //
// radio.vue?24dc9765